import { useRef } from 'react';

export const useSound = (soundFile) => {
    const audioRef = useRef(null);

    if (!audioRef.current) {
        audioRef.current = new Audio(soundFile);
    }

    const play = () => {
        audioRef.current.currentTime = 0;
        audioRef.current.play().catch((e) => console.log('Audio play failed:', e));
    };

    return play;
};
